import styled from 'styled-components';

export const UploadImageMobileModal = styled.div`
	& .modal-overlay-bot {
		justify-content: center;

		& > .modal-container-bot {
			max-height: 400px;
			height: fit-content !important;
			border-radius: 20px !important;
			box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.25);
		}
	}
	&.loader {
		& .modal-container-bot {
			width: fit-content !important;
		}
		& .uploading-loader {
			display: inline-flex;
			padding: 24px;
			flex-direction: column;
			align-items: center;
			gap: 8px;
			& > svg {
				animation: spin 1s linear infinite;
			}
			& > div {
				color: var(--primary-color-ff-primary500);
			}
		}
		@keyframes spin {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(360deg);
			}
		}
	}
	&.error {
		& .modal-container-bot {
			max-width: calc(100% - 30px) !important;
		}
		& .error-message {
			padding: 24px;
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: center;
			& > .msg1 {
				margin-top: 20px;
				font-weight: 600;
				color: var(--text-dark-on-light, #1c0047);
			}

			& > .msg2 {
				margin-top: 12px;
				color: var(--primary-color-ff-primary900);
			}
			& > .custom-button {
				margin-top: 24px;
				& > button {
					background-color: var(--primary-color-ff-primary600) !important;
					padding: 5px 16px !important;
					border-radius: 100px !important;

					&:not(.Mui-disabled):hover {
						&:after {
							border-radius: 100px;
						}
					}

					&:not(.Mui-disabled):focus,
					&:not(.Mui-disabled):active {
						&:after {
							border-radius: 100px;
						}
					}
				}
			}
		}
	}
`;

export const MobileUploadContainer = styled.div`
	&.tablet {
		& > div:not(.ff-image-preview) {
			width: calc(100vw - 48px);
		}
	}
	& > div:not(.ff-image-preview) {
		display: flex;
		flex-direction: column;
		gap: 20px;
		position: fixed;
		bottom: 0;
		padding: 24px 24px 36px 24px;
		border-radius: 20px 20px 0px 0px;
		background: #fff;
		box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.25);
		z-index: 5;
		& > .svg-holder {
			display: flex;
			justify-content: center;
		}
		& > .error-image {
			color: #c92929;
		}
		& > div {
			color: var(--primary-color-ff-primary900);
			text-align: center;
		}
		& > .title-search-mobile {
			margin: 0;
			font-size: 20px;
			color: var(--primary-color-ff-primary900);
			text-align: center;
		}
		& > label {
			& > .custom-button {
				& > .MuiButtonBase-root {
					height: unset !important;
					width: 100%;
					border-radius: 100px !important;
					background-color: #7242e1 !important;
					padding: 5px 16px !important;
					& > .custom-button-body {
						position: relative;
						top: 1px;
					}
				}
			}
		}
		& > .separator {
			display: flex;
			align-items: center;
			gap: 10px;
			margin: 8px 0;
			& > .separator-line {
				width: 100%;
				height: var(--border-radius-size-1, 1px);
				background: var(--black-10, rgba(0, 0, 0, 0.1));
			}
			& > .separator-text {
				color: black;
			}
		}
		& .ff-input {
			max-width: unset !important;
			& .MuiInputBase-root {
				border-radius: 16px;
				border: 1px solid rgba(0, 0, 0, 0.2);
				background: #fff;
			}
		}
	}
	& > .ff-image-preview {
		position: fixed;
		top: 50%;
		transform: translateY(-50%);
		left: 0;
		right: 0;
		justify-items: center;
		background-color: rgba(0, 0, 0, 0.6);
		height: 100vh;
		width: 100vw;
		align-content: center;
		z-index: 6;
		& > img {
			width: 380px;
			aspect-ratio: 1;
			object-fit: cover;
			object-position: center;
		}
		& > div.image-buttons {
			display: flex;
			justify-content: center;
			gap: 12px;
			margin-top: 10px;
			& > .custom-button:first-child {
				& > button {
					border-radius: 20px;
					border: 1px solid #cfbced;
					background: #f6f2fb;
					padding: 3px 16px;
					height: unset;
					& > div {
						color: #4800ba;
					}
				}
			}
			& > .custom-button:last-child {
				& > button {
					border-radius: 20px;
					padding: 5px 16px;
					height: unset;
					& > div {
					}
				}
			}
		}
	}
`;
